"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventChangeScope = exports.CalendarEventRepetitionType = exports.CalendarEventStatus = exports.CalendarEventType = void 0;
var CalendarEventType;
(function (CalendarEventType) {
    CalendarEventType["TASK"] = "TASK";
    CalendarEventType["VISIT"] = "VISIT";
})(CalendarEventType || (exports.CalendarEventType = CalendarEventType = {}));
/**
 * @ONGOING - Event is currently happening
 * @CANCELLED - Event has been cancelled
 * @OUTDATED - Event is no longer relevant or valid
 * @COMPLETED - Event has been successfully completed
 * @DELETED - Event has been deleted
 * @ARCHIVED - Event has been archived
 * @PENDING - Event is pending and has not yet started
 * @PLANNED - Event is accepted and is awaiting to start
 * @DECLINED - Event that was pending for approval but was declined
 */
var CalendarEventStatus;
(function (CalendarEventStatus) {
    CalendarEventStatus["ONGOING"] = "ONGOING";
    CalendarEventStatus["CANCELLED"] = "CANCELLED";
    CalendarEventStatus["OUTDATED"] = "OUTDATED";
    CalendarEventStatus["COMPLETED"] = "COMPLETED";
    CalendarEventStatus["DELETED"] = "DELETED";
    CalendarEventStatus["ARCHIVED"] = "ARCHIVED";
    CalendarEventStatus["PENDING"] = "PENDING";
    CalendarEventStatus["PLANNED"] = "PLANNED";
    CalendarEventStatus["DECLINED"] = "DECLINED";
})(CalendarEventStatus || (exports.CalendarEventStatus = CalendarEventStatus = {}));
var CalendarEventRepetitionType;
(function (CalendarEventRepetitionType) {
    CalendarEventRepetitionType["DAILY"] = "daily";
    CalendarEventRepetitionType["WEEKLY"] = "weekly";
    CalendarEventRepetitionType["WEEKDAYS"] = "weekdays";
    CalendarEventRepetitionType["MONTHLY"] = "monthly";
    CalendarEventRepetitionType["YEARLY"] = "yearly";
    CalendarEventRepetitionType["NEVER"] = "never";
})(CalendarEventRepetitionType || (exports.CalendarEventRepetitionType = CalendarEventRepetitionType = {}));
var EventChangeScope;
(function (EventChangeScope) {
    EventChangeScope["THIS_EVENT"] = "THIS_EVENT";
    EventChangeScope["THIS_AND_FUTURE_EVENTS"] = "THIS_AND_FUTURE_EVENTS";
    EventChangeScope["ALL_EVENTS"] = "ALL_EVENTS";
})(EventChangeScope || (exports.EventChangeScope = EventChangeScope = {}));
